import { createSelector } from '@ngrx/store';

import { getCustomQuickorderState } from '../custom-quickorder-store';

const getQuickOrderState = createSelector(getCustomQuickorderState, state => state.quickOrder);

export const getQuickOrderLoading = createSelector(getQuickOrderState, state => state.loading);

export const getQuickOrder = createSelector(getQuickOrderState, quickOrderState => quickOrderState.quickOrder);

export const getQuickOrderValidations = createSelector(
  getQuickOrderState,
  quickOrderState => quickOrderState.validationErrors
);

export const getQuickOrderID = createSelector(getQuickOrderState, quickOrderState =>
  quickOrderState.quickOrder ? quickOrderState.quickOrder.wishlistId : undefined
);

export const getQuickOrderItemsCount = createSelector(getQuickOrderState, quickOrderState =>
  quickOrderState.quickOrder ? quickOrderState.quickOrder.noOfItems : undefined
);
